import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  jump(event) {
    const target = document.getElementById(this.idValue)
    if (!target) return

    event.preventDefault()
    target.scrollIntoView({ behavior: "smooth", block: "center" })
    target.classList.remove("timeline-pulse")
    void target.offsetWidth
    target.classList.add("timeline-pulse")
  }
}
